import React from "react";
import { useNavigate } from "react-router-dom";

const Navbar = (props) => {
  const { menuItem } = props;
  const navigate = useNavigate();

  return (
    <nav id="main-menu" className="ms-auto">
      <ul>
        {menuItem.map((item, index) => (
          <li key={index * (Math.random() * 1)}>
            <a
              href={`#${item}`}
              onClick={() => navigate("/terangatours/home")}
              className="nav-link"
            >
              {" "}
              {item}
            </a>
            {item === "forfait"}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navbar;
